import React from "react"

export enum LinkListBehavior {
  LIST = "LIST",
  ACCORDION = "ACCORDION"
}

export interface LinkListContextType {
  behavior: LinkListBehavior
  onClick?: () => void
}

export const LinkListContext = React.createContext<LinkListContextType>({
  behavior: LinkListBehavior.LIST
})
